

























































import store from '@/store/store'
import html2canvas from 'html2canvas'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class PopUpListComponent extends Vue {
  @Prop() private title!: string
  @Prop() private options!: PopUpListOption[]
  @Prop() private showValue!: boolean
  public selected: PopUpListOption = { Name: '', Value: '', NativeName: '', Alpha2Code: '' }
  public searchterm = ''
  private imageScreenshot = ''
  private screenshotLoading = false
  public isMounted = false
  public switchIcon = true
  public searchFocus = false

  public mounted () {
    this.isMounted = true
  }

  public openAeroguestSupport () {
    this.screenshotLoading = true
    try {
      html2canvas(document.body, { useCORS: true, scrollY: 0 }).then(async (canvas) => {
        this.imageScreenshot = await canvas.toDataURL('image/jpeg', 1)
        this.$router.push({ name: 'support', params: this.$route.params })
        store.saveSupportData({ img: this.imageScreenshot, enableImg: true, title: 'countrycodesheet' })
      })
    } catch (error) {
      console.log(error)
    }
  }

  public select (event: any) {
    this.selected = event
    this.$emit('change-selected', this.selected)
  }

  public filteredList () {
    return this.options.filter((options) => {
      return Object.values(options).some((value) => String(value).toLowerCase().includes(this.searchterm.toLowerCase()))
    })
  }

  public switchXAndSearchIcon () {
    if (this.searchterm !== '') {
      this.switchIcon = false
    } else {
      this.switchIcon = true
    }
  }

  public clearSearchBar () {
    this.searchterm = ''
  }
}
export interface PopUpListOption {
  Name: string;
  Value: string;
  NativeName: string;
  Alpha2Code: string;
}

